export enum TypeOfDataType {
  SIMPLES = 0,
  DATA_TYPE_COMPOUND = 1,
  DATA_TYPE_VECTOR = 2,
  DATA_TYPE_RESTRICTED = 3,
  DATA_TYPE_VALIDATED_VECTOR = 4
}

